import { SVGProps } from "react";

// Progress 25%. Quarter-filled ring icon used by goal progress chips.
const Progress25 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8 3.5C10.4853 3.5 12.5 5.51472 12.5 8H8V3.5ZM12.9814 7.58789C12.9928 7.72479 13 7.86219 13 8C13 7.86119 12.9925 7.72384 12.9814 7.58789ZM8 3C8.10408 3 8.20792 3.00426 8.31152 3.01074C8.20847 3.00441 8.10465 3 8 3Z"
    />
  </svg>
);

export default Progress25;
